const MAX_PIN_ATTEMPTS = 5;
const PIN_LOCK_MS = 5 * 60 * 1000;

const getTenantId = () => localStorage.getItem('currentRestaurantId') || 'no-tenant';

const getKey = (scope) => `pin_guard:${getTenantId()}:${scope}`;

const readState = (scope) => {
  try {
    return JSON.parse(localStorage.getItem(getKey(scope))) || { attempts: 0, lockedUntil: 0 };
  } catch {
    return { attempts: 0, lockedUntil: 0 };
  }
};

const writeState = (scope, state) => {
  localStorage.setItem(getKey(scope), JSON.stringify(state));
};

export const getPinLockState = (scope) => {
  const state = readState(scope);
  const now = Date.now();

  if (state.lockedUntil && state.lockedUntil > now) {
    return {
      locked: true,
      remainingMs: state.lockedUntil - now,
      attempts: state.attempts || 0,
    };
  }

  if (state.lockedUntil && state.lockedUntil <= now) {
    writeState(scope, { attempts: 0, lockedUntil: 0 });
  }

  return { locked: false, remainingMs: 0, attempts: state.attempts || 0 };
};

export const recordPinFailure = (scope) => {
  const state = readState(scope);
  const attempts = (state.attempts || 0) + 1;
  const lockedUntil = attempts >= MAX_PIN_ATTEMPTS ? Date.now() + PIN_LOCK_MS : 0;
  const nextState = { attempts, lockedUntil };

  writeState(scope, nextState);

  return {
    locked: Boolean(lockedUntil),
    attempts,
    remainingAttempts: Math.max(MAX_PIN_ATTEMPTS - attempts, 0),
    remainingMs: lockedUntil ? PIN_LOCK_MS : 0,
  };
};

export const clearPinFailures = (scope) => {
  localStorage.removeItem(getKey(scope));
};

export const formatPinLockMessage = (remainingMs) => {
  const minutes = Math.max(1, Math.ceil((remainingMs || PIN_LOCK_MS) / 60000));
  return `Too many wrong PIN attempts. Try again in ${minutes} minute${minutes === 1 ? '' : 's'}.`;
};

export const formatPinFailureMessage = (failure) => {
  if (failure.locked) return formatPinLockMessage(failure.remainingMs);
  return `Invalid PIN. ${failure.remainingAttempts} attempt${failure.remainingAttempts === 1 ? '' : 's'} left.`;
};
